import btnStyle from '@/components/Shares/Button.module.css';
import { CopyWalletButton } from '@/components/Shares/CopyWalletButton';
import inputStyle from '@/components/Shares/Input.module.css';
import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Box, Button, Card, Flex, Group, Image, Input, Paper, Stack, Text, rem } from '@mantine/core';
export const Security2FA: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="var(--bg-400)" p={{
    base: 10,
    sm: 20
  }}>
      <Text fz={{
      base: rem(14),
      sm: rem(18)
    }} mt={{
      base: 10,
      sm: 12
    }} className={gunterzBold.className}>
        {i18n._('Enable 2fa')}
      </Text>

      <Text c="var(--text-color-dark_theme)" fz={rem(13)}>
        {i18n._('To keep your account extra secure leave a two factor authentication enabled.')}
      </Text>

      <form>
        <Flex direction={{
        base: 'column',
        sm: 'row',
        lg: 'column'
      }} gap={24} tt="uppercase" fw={700} mt={{
        base: 24,
        sm: 40,
        lg: 32
      }}>
          <Stack flex={1} gap={24}>
            <Stack gap={0}>
              <Text fz={rem(12)} c="var(--text-prime)" fw="inherit">
                {i18n._('Copy this code in your authenticator app')}
              </Text>
              <Paper px={15} py={6} mt={14} radius={5} bg="var(--input-variant-color)">
                <Group wrap="nowrap" gap={4} justify="space-between">
                  <Box w={{
                  base: 290,
                  sm: 330
                }}>
                    <Text fz={13} fw={700} c="var(--text-grey-4)" truncate="end">
                      {'ONEGKR2PHJQW4OCUJFMFOYR4OYSEAMKUJJASDADHFDSDSDHH'}
                    </Text>
                  </Box>

                  <CopyWalletButton value="ONEGKR2PHJQW4OCUJFMFOYR4OYSEAMKUJJASDADHFDSDSDHH" />
                </Group>
              </Paper>
            </Stack>

            <Box visibleFrom="lg">
              <Text fz={rem(12)} c="var(--text-prime)" fw="inherit">
                {i18n._('Or Scan this code')}
              </Text>
              <Image src="/assets/wallet/qr_code.svg" w={203} h={203} mt={14} />
            </Box>

            <Input.Wrapper withAsterisk label={i18n._('Password')} classNames={{
            label: inputStyle.input_label,
            required: inputStyle.required
          }}>
              <Input mt={14} placeholder={i18n._('Enter password')} classNames={{
              input: inputStyle.input_style_2
            }} />
            </Input.Wrapper>

            <Input.Wrapper withAsterisk label={i18n._('Two Factor Code')} classNames={{
            label: inputStyle.input_label,
            required: inputStyle.required
          }}>
              <Input mt={14} placeholder={i18n._('Enter code')} classNames={{
              input: inputStyle.input_style_2
            }} />
            </Input.Wrapper>
          </Stack>
          <Box visibleFrom="sm" hiddenFrom="lg">
            <Text fz={rem(12)} c="var(--text-prime)" fw="inherit">
              {i18n._('Or Scan this code')}
            </Text>
            <Image src="/assets/wallet/qr_code.svg" w={203} h={203} mt={14} />
          </Box>
        </Flex>
        <Button w={96} mt={{
        base: 24,
        sm: 20
      }} classNames={{
        root: btnStyle.button_style_2
      }}>
          {i18n._('Enable')}
        </Button>
      </form>
    </Card>;
};